import React from 'react';
import config from '../config';
import HomeLegacy from './HomeLegacy';
import HomeNext from './HomeNext';

function Home() {
  if ((config.landingVariant || '').toLowerCase() === 'next') {
    return <HomeNext />;
  }

  return <HomeLegacy />;
}

export default Home;
